export const PLATFORM_TYPE = {
  1: 'PC端',
  2: '移动端',
}
export const SUBJECT_TYPE = {
  black: '黑夜',
  white: '白天',
}

export const POSITION_TYPE = {
  1: '广告位一',
  2: '广告位二',
  3: '广告位三',
  4: '广告位四',
  5: '广告位五',
  6: '广告位六',
  7: '广告位七',
  8: '广告位八',
  9: '广告位九',
  10: '广告位十',
}

export const CODE = {
  1: 'U本位合约首页',
  2: '超级合约首页',
  3: '充值首页',
  4: '邀请首页',
}

export const CODE_LIST = [
  { value: 'U本位合约首页', code: 1 },
  { value: '行情首页', code: 2 },
  { value: '充值首页', code: 3 },
  { value: '邀请首页', code: 4 },
  { value: '跟单首页', code: 5 },
  { value: '资产首页', code: 6 },
  { value: '首页', code: 7 },
]
